import { createSelector } from '@ngrx/store';

import * as fromIndexReducers from '../reducers';
import * as fromReducer from '../reducers/pubmed.reducer';

const getPubmedsState = createSelector(
    fromIndexReducers.getProtocolsFeatureState,
    (state: fromIndexReducers.ProtocolsFeatureState) => state.pubmeds
);
export const getPubmeds = createSelector(
    getPubmedsState,
    fromReducer.LoadPubmeds
);
